import { Component, Input, inject } from "@angular/core";
import { RnsidebarService } from "../../../../services/sidebar/rnsidebar.service";

@Component({
    selector: "app-rn-right-sidebar",
    templateUrl: "./rn-right-sidebar.component.html",
    styleUrls: ["./rn-right-sidebar.component.scss"],
    standalone: false
})
export class RightSideBarComponent {
  private rnsidebarService = inject(RnsidebarService);

  @Input() componentName = "";
  @Input() data: any;
  @Input() additionalData: any;
  public Loading = true;

  componentLoaded(loaded: boolean) {
    this.Loading = !loaded;
  }
}
